import { useState } from 'react'
import api from '../../utils/api'
import useToastContext from '../useToastContext'
import { notificationTypes } from '../../contexts/toastContext'

const useMonthlyReportsApi = () => {
  const addToast = useToastContext()

  const [configsState, setConfigsState] = useState({
    configs: [],
    isLoading: false,
    error: null,
  })

  async function getConfigs() {
    try {
      setConfigsState((current) => ({ ...current, isLoading: true, error: null }))
      const response = await api.get('/monthlyReportConfigs', {
        includeToken: true,
      })
      setConfigsState({
        configs: response.data?.data || [],
        isLoading: false,
        error: null,
      })
      return response.data?.data || []
    } catch (error) {
      setConfigsState({
        configs: [],
        isLoading: false,
        error: error.response?.data?.message || 'Error al obtener reportes',
      })
      addToast(
        notificationTypes.error,
        error.response?.data?.message || 'Error al obtener reportes'
      )
    }
  }

  async function createConfig(payload) {
    try {
      await api.post('/monthlyReportConfigs', payload, { includeToken: true })
      addToast(notificationTypes.success, 'Reporte mensual creado')
      await getConfigs()
    } catch (error) {
      addToast(
        notificationTypes.error,
        error.response?.data?.message || 'Error al crear reporte mensual'
      )
      throw error
    }
  }

  async function updateConfig(id, payload) {
    try {
      await api.put(`/monthlyReportConfigs/${id}`, payload, {
        includeToken: true,
      })
      addToast(notificationTypes.success, 'Reporte mensual actualizado')
      await getConfigs()
    } catch (error) {
      addToast(
        notificationTypes.error,
        error.response?.data?.message || 'Error al actualizar reporte mensual'
      )
      throw error
    }
  }

  async function deleteConfig(id) {
    try {
      await api.remove(`/monthlyReportConfigs/${id}`, { includeToken: true })
      addToast(notificationTypes.success, 'Reporte mensual eliminado')
      await getConfigs()
    } catch (error) {
      addToast(
        notificationTypes.error,
        error.response?.data?.message || 'Error al eliminar reporte mensual'
      )
      throw error
    }
  }

  return [{ configsState }, { getConfigs, createConfig, updateConfig, deleteConfig }]
}

export default useMonthlyReportsApi
